import { toast } from 'react-toastify';
import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';

import { setIsWaiting, setIsLoading, setRemoveLoading, setShowRemovePopup, setShowPopup, setShowPopupDetail } from '../../../../actions/general';
import { setAdminDataAddProduct } from '../GlobalStates/DataAddProduct/actions';

export const GET_SYSTEM_ADMIN_INSTRUCTOR = 'getSystemAdminInstructor';
export const ADD_SYSTEM_ADMIN_INSTRUCTORS = 'addSystemAdminInstructors';
export const ADD_SYSTEM_ADMIN_INSTRUCTOR = 'addSystemAdminInstructor';
export const UPDATE_SYSTEM_ADMIN_INSTRUCTOR = 'updateSystemAdminInstructor';
export const DELETE_SYSTEM_ADMIN_INSTRUCTOR = 'deleteSystemAdminInstructor';
export const API_SYSTEM_ADMIN_INSTRUCTORS = 'instructor';
export const API_SYSTEM_ADMIN_INSTRUCTOR = 'instructor/:id';

export const fetchSystemAdminInstructor = (instructorId) => {
     return {
          type: GET_SYSTEM_ADMIN_INSTRUCTOR,
          payload: instructorId,
     };
};

export const addSystemAdminInstructor = (instructor) => {
     return {
          type: ADD_SYSTEM_ADMIN_INSTRUCTOR,
          payload: instructor,
     };
};

export const addSystemAdminInstructors = (instructors) => {
     return {
          type: ADD_SYSTEM_ADMIN_INSTRUCTORS,
          payload: instructors,
     };
};

export const updateSystemAdminInstructor = (instructor) => {
     return {
          type: UPDATE_SYSTEM_ADMIN_INSTRUCTOR,
          payload: instructor,
     };
};

export const deleteSystemAdminInstructor = (instructorId) => {
     return {
          type: DELETE_SYSTEM_ADMIN_INSTRUCTOR,
          payload: instructorId,
     };
};

export const addInstructorToDataAddProduct = (instructor) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct?.instructors) {
          const newInstructor = {
               id: instructor.id,
               name: instructor.name,
          };
          dataAddProduct.instructors.push(newInstructor);
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const updateInstructorToDataAddProduct = (instructor) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newDataInstructors = dataAddProduct.instructors.map((instructorItem) => {
               const newInstructor = {
                    id: instructor.id,
                    name: instructor.name,
               };
               if (instructorItem.id === newInstructor.id) {
                    return { ...instructorItem, ...newInstructor };
               }
               return instructorItem;
          });
          dataAddProduct.instructors = newDataInstructors;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const deleteInstructorFromDataAddProduct = (id) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newInstructors = dataAddProduct.instructors.filter((instructorItem) => instructorItem.id !== id);
          dataAddProduct.instructors = newInstructors;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const fetchSystemAdminInstructors = () => (dispatch) => {
     dispatch(setIsLoading(true));
     return callApi(API_SYSTEM_ADMIN_INSTRUCTORS, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addSystemAdminInstructors(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const addSystemAdminInstructorRequest = (instructor) => (dispatch) => {
     dispatch(setIsWaiting(true));

     return callApi(API_SYSTEM_ADMIN_INSTRUCTORS, 'POST', instructor)
          .then((response) => {
               dispatch(setIsWaiting(false));
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newInstructor = response.data;

               dispatch(addSystemAdminInstructor(newInstructor));

               dispatch(addInstructorToDataAddProduct(newInstructor));
               dispatch(setShowPopup());
               toast.success('Created Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateSystemAdminInstructorRequest = (instructorId, newInstructor) => (dispatch) => {
     return callApi(API_SYSTEM_ADMIN_INSTRUCTOR.replace(':id', instructorId), 'PUT', newInstructor)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newInstructor = response.data;

               dispatch(updateSystemAdminInstructor(newInstructor));

               dispatch(updateInstructorToDataAddProduct(newInstructor));

               dispatch(setShowPopupDetail(null));
               toast.success('Update Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const deleteSystemAdminInstructorRequest = (instructorId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     return callApi(API_SYSTEM_ADMIN_INSTRUCTOR.replace(':id', instructorId), 'DELETE')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(deleteSystemAdminInstructor(instructorId));
               dispatch(deleteInstructorFromDataAddProduct(instructorId));
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup());
          });
};

export const removeAdminInstructor = (instructorId, instructors, nextDispatch) => (dispatch) => {
     const { setInstructorId, setShowRelatedObjectWarningPopup } = nextDispatch;

     const itemSelected = instructors.find((item) => item.instructorId === instructorId);
     if (itemSelected?.productInstructors?.length > 0) {
          setShowRelatedObjectWarningPopup(true);
     } else {
          setInstructorId(instructorId);
          dispatch(setShowRemovePopup());
     }
};
